<!--
  ~ Copyright 2015-2023 Ritense BV, the Netherlands.
  ~
  ~ Licensed under EUPL, Version 1.2 (the "License");
  ~ you may not use this file except in compliance with the License.
  ~ You may obtain a copy of the License at
  ~
  ~ https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
  ~
  ~ Unless required by applicable law or agreed to in writing, software
  ~ distributed under the License is distributed on an "AS IS" basis,
  ~ WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  ~ See the License for the specific language governing permissions and
  ~ limitations under the License.
  -->

<v-form
  (valueChange)="formValueChange($event)"
  *ngIf="{
    disabled: disabled$ | async,
    prefill: prefillConfiguration$ ? (prefillConfiguration$ | async) : null
  } as obs"
>
  <v-input
    name="configurationTitle"
    [title]="'configurationTitle' | pluginTranslate : pluginId | async"
    [margin]="true"
    [disabled]="obs.disabled"
    [defaultValue]="obs.prefill?.configurationTitle"
    [required]="true"
    [tooltip]="'configurationTitleTooltip' | pluginTranslate : pluginId | async"
    [widthPx]="350"
  >
  </v-input>
  <v-input
    name="url"
    [title]="'url' | pluginTranslate : pluginId | async"
    [fullWidth]="true"
    [margin]="true"
    [disabled]="obs.disabled"
    [defaultValue]="obs.prefill?.url"
    [required]="true"
    [tooltip]="'urlTooltip' | pluginTranslate : pluginId | async"
  >
  </v-input>
  <v-input
    name="callbackUrl"
    [title]="'callbackUrl' | pluginTranslate : pluginId | async"
    [fullWidth]="true"
    [margin]="true"
    [disabled]="obs.disabled"
    [defaultValue]="obs.prefill?.callbackUrl"
    [required]="true"
    [tooltip]="'callbackUrlTooltip' | pluginTranslate : pluginId | async"
  >
  </v-input>
  <ng-container
    *ngIf="{authenticationPluginSelectItems: authenticationPluginSelectItems$ | async} as authObs"
  >
    <v-select
      [items]="authObs.authenticationPluginSelectItems"
      [margin]="true"
      [widthInPx]="350"
      name="authenticationPluginConfiguration"
      [title]="'authenticationPluginConfiguration' | pluginTranslate : pluginId | async"
      [disabled]="obs.disabled"
      [defaultSelectionId]="obs.prefill?.authenticationPluginConfiguration"
      [required]="true"
      [loading]="!authObs.authenticationPluginSelectItems"
    ></v-select>
  </ng-container>
</v-form>
